/**
 * Unread badges cap at 99+ (AC). Shared by the top-bar bell and the sidebar
 * notifications cell.
 */
export function formatBadgeCount(count: number): string {
  return count > 99 ? '99+' : String(count);
}
